/**
 * Maus-Drag-Scroll + Prev/Next-Buttons für .cart-crosssell__scroller
 * (Cart-Cross-Sell Swipe auf Desktop).
 * Event-Delegation auf document, damit Re-Renders des Mini-Cart-Drawers automatisch
 * mitgreifen — keine Reinit nötig.
 */
(function () {
  if (window.__cartCrosssellDragInit) return;
  window.__cartCrosssellDragInit = true;

  var DRAG_THRESHOLD = 10;
  // Der ATC-Button darf NIE als Drag interpretiert werden — sonst schluckt
  // onClickCapture den Klick und "Add to Cart" reagiert nicht (v.a. mobil,
  // wo ein Finger-Tap auf dem 16px-Button leicht >5px wandert).
  var ADD_BTN = '.cart-crosssell__add';
  var isDown = false;
  var moved = 0;
  var startX = 0;
  var startScrollLeft = 0;
  var activeScroller = null;

  function getViewportNavs(scroller) {
    var viewport = scroller.parentElement;
    if (!viewport) return { prev: null, next: null };
    return {
      prev: viewport.querySelector('.cart-crosssell__nav--prev'),
      next: viewport.querySelector('.cart-crosssell__nav--next'),
    };
  }

  function getCardStep(scroller) {
    var card = scroller.querySelector('.cart-crosssell__card');
    if (!card) return scroller.clientWidth || 240;
    var styles = window.getComputedStyle(scroller);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateNavState(scroller) {
    var navs = getViewportNavs(scroller);
    if (!navs.prev && !navs.next) return;
    var max = scroller.scrollWidth - scroller.clientWidth - 1;
    var noScrollNeeded = scroller.scrollWidth <= scroller.clientWidth + 1;
    if (navs.prev) navs.prev.toggleAttribute('disabled', scroller.scrollLeft <= 0);
    if (navs.next) navs.next.toggleAttribute('disabled', scroller.scrollLeft >= max);
    var viewport = scroller.parentElement;
    if (viewport) {
      viewport.classList.toggle('cart-crosssell__viewport--no-scroll', noScrollNeeded);
    }
  }

  // --- Drag ---
  function onMouseDown(e) {
    if (e.button !== 0) return;
    // Presses auf dem ATC-Button starten keinen Drag — der Klick muss
    // unverändert zum <add-to-cart>-Element durchkommen.
    if (e.target.closest(ADD_BTN)) return;
    var scroller = e.target.closest('.cart-crosssell__scroller');
    if (!scroller) return;

    isDown = true;
    moved = 0;
    activeScroller = scroller;
    startX = e.pageX - scroller.getBoundingClientRect().left;
    startScrollLeft = scroller.scrollLeft;
    scroller.classList.add('cart-crosssell__scroller--dragging');
  }

  function onMouseMove(e) {
    if (!isDown || !activeScroller) return;
    var x = e.pageX - activeScroller.getBoundingClientRect().left;
    var walk = x - startX;
    moved = Math.max(moved, Math.abs(walk));
    activeScroller.scrollLeft = startScrollLeft - walk;
    updateNavState(activeScroller);
    e.preventDefault();
  }

  function endDrag() {
    if (!activeScroller) return;
    activeScroller.classList.remove('cart-crosssell__scroller--dragging');
    updateNavState(activeScroller);
    activeScroller = null;
    isDown = false;
  }

  function onClickCapture(e) {
    // ATC-Button immer durchlassen, egal wie viel vorher gescrollt wurde.
    if (e.target.closest(ADD_BTN)) {
      moved = 0;
      return;
    }
    if (moved > DRAG_THRESHOLD) {
      e.preventDefault();
      e.stopPropagation();
    }
    // moved IMMER zurücksetzen, damit kein veralteter Wert spätere Klicks frisst.
    moved = 0;
  }

  // --- Nav Buttons ---
  function onNavClick(e) {
    var btn = e.target.closest('.cart-crosssell__nav');
    if (!btn) return;
    var viewport = btn.closest('.cart-crosssell__viewport');
    if (!viewport) return;
    var scroller = viewport.querySelector('.cart-crosssell__scroller');
    if (!scroller) return;
    var step = getCardStep(scroller);
    var direction = btn.classList.contains('cart-crosssell__nav--prev') ? -1 : 1;
    scroller.scrollBy({ left: step * direction, behavior: 'smooth' });
    // Nav-State leicht verzögert updaten nach Scroll
    setTimeout(function () { updateNavState(scroller); }, 350);
  }

  // --- Scroll listener für Nav-State (delegiert nicht, wird pro Scroller initialisiert) ---
  function attachScrollListener(scroller) {
    if (scroller.__navListenerAttached) return;
    scroller.__navListenerAttached = true;
    scroller.addEventListener('scroll', function () { updateNavState(scroller); }, { passive: true });
    updateNavState(scroller);
  }

  function initAllScrollers() {
    document.querySelectorAll('.cart-crosssell__scroller').forEach(attachScrollListener);
  }

  // Bei DOM-Mutationen (Cart-Drawer-Re-Render) Scroller neu attachen
  var mo = new MutationObserver(function () { initAllScrollers(); });
  mo.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('mousedown', onMouseDown);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', endDrag);
  document.addEventListener('mouseleave', endDrag);
  document.addEventListener('click', onClickCapture, true);
  document.addEventListener('click', onNavClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllScrollers);
  } else {
    initAllScrollers();
  }
})();
